import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import Translator from "../../helpers/Translator";
import { axiosPath } from "../../../../routing/helpers/router";
import useIsMounted from "../../hooks/useIsMounted";

export default function SelectResponsible(props) {
  const {
    value,
    onHandleChange,
    className = "mb-2",
    title = "",
    isMulti = true,
    hasSearchBox = false,
    hasSelectOptions = false,
    isClearable = false,
    hasNoResponsibleOption = false,
    onlyWithPlantAccess = false,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [responsibles, setResponsibles] = useState();

  // > LOAD RESPONSIBLES //
  useEffect(() => {
    (async () => {
      await axios
        .post(
          axiosPath(
            "api_r_user_module_legalCompliance_responsible_getResponsibles"
          ),
          { moduleBridgeHex, plantHex, onlyWithPlantAccess }
        )
        .then((r) => {
          if (isMounted.current) {
            setResponsibles(
              hasNoResponsibleOption
                ? [r.data.hasNoResponsibleOption, ...r.data.responsibles]
                : r.data.responsibles
            );
          }
        });
    })();
  }, []);
  // < LOAD RESPONSIBLES //

  return (
    <AppMultiSelect
      options={responsibles}
      title={
        title ||
        ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="responsibles" />
        )
      }
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="select.one.or.multiple.responsibles"
        />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="group" />}
      isLoading={!responsibles}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
    />
  );
}
